<template>
<!-- 模型评估报告 -->
  <div class="model-assessment-report">
    <gat-head class="courseDetails-head" ref="gatHead"></gat-head>
    <div class="nav-head-right">
      <div class="go-to-dataset" @click="onBlackModel">
        <i class="el-icon el-icon-right"></i>
        <span>返回</span>
      </div>
    </div>
    <div class="popup-content">
      <div class="pdfCentent" id="pdfCentent" ref="pdf">
        <div class="progress">
          <!-- <div class="progress scroll-bar"> -->
          <h3 class="p">评估报告</h3>
          <div class="userName p">{{TrainingModelReport.realName}}（ {{currentdate}} ）</div>
          <h4 class="p">模型信息</h4>
          <div class="p">
            <p>
              <span><em class="span-color-black">模型名称：</em><em class="text">{{TrainingModelReport.modelName}}</em></span>
              <span><em class="span-color-black">版本号：</em><em class="text">{{TrainingModelReport.version}}</em></span>
            </p>
            <p>
              <span><em class="span-color-black">模型类型：</em><em class="text">{{TrainingModelReport.type==1 ? '图像分类':'物体检测'}}</em></span>
              <span><em class="span-color-black">模型ID：</em><em class="text">{{TrainingModelReport.trainModelId}}</em></span>
            </p>
            <p>
              <span>
                <em class="span-color-black">模型描述：</em><em class="text">{{TrainingModelReport.modelFuncDesc}}</em>
              </span>
            </p>
          </div>
    
          <h4 class="p">数据信息</h4>
          <div class="p">
            <h6>训练集</h6>
            <el-table :data="TrainingModelReport.trainSetList" border style="width: 100%" :cell-style="{padding: '0'}" :header-cell-style="{color:'#333', fontWeight: '600'}">
              <el-table-column align="center" prop="datasetName" label="数据集名称"></el-table-column>
              <el-table-column align="center" prop="version" label="版本号" width="100"></el-table-column>
              <el-table-column align="center" prop="dataNum" label="数据总量" width="100"></el-table-column>
              <el-table-column align="center" :prop="datasetType == 1 ? 'imgNum' : 'tagNum'" :label="datasetType == 1 ? '图片数':'已标注'" width="100"></el-table-column>
              <el-table-column align="center" prop="labelNames" label="标签名称"></el-table-column>
              <!-- ele 无数据提示插槽 -->
              <template slot="empty"><div class="noData">无数据</div></template>
            </el-table>
          </div>
          <div class="p">
            <h6>验证集<span class="span-color-ash" v-show="!(TrainingModelReport.validationSetList && TrainingModelReport.validationSetList.length)">（系统随机分配）</span></h6>
            <el-table 
              v-if="TrainingModelReport.validationSetList && TrainingModelReport.validationSetList.length"
              :data="TrainingModelReport.validationSetList" 
              border style="width: 100%" :cell-style="{padding: '0'}" 
              :header-cell-style="{color:'#333', fontWeight: '600'}"
            >
              <el-table-column align="center" prop="datasetName" label="数据集名称"></el-table-column>
              <el-table-column align="center" prop="datasetVersion" label="版本号" width="100"></el-table-column>
              <el-table-column align="center" prop="datasetNum" label="数据总量" width="100"></el-table-column>
              <el-table-column align="center" prop="labelIdNum" :label="datasetType == 1 ? '图片数':'已标注'" width="100"></el-table-column>
              <el-table-column align="center" prop="labelNames" label="标签名称"></el-table-column>
              <!-- ele 无数据提示插槽 -->
              <template slot="empty"><div class="noData">无数据</div></template>
            </el-table>
          </div>
          <div class="p">
            <h6>测试集<span class="span-color-ash" v-show="!(TrainingModelReport.testSetList && TrainingModelReport.testSetList.length)">（系统随机分配）</span></h6>
            <el-table
              v-if="TrainingModelReport.testSetList && TrainingModelReport.testSetList.length"
              :data="TrainingModelReport.testSetList" border style="width: 100%" 
              :cell-style="{padding: '0'}" 
              :header-cell-style="{color:'#333', fontWeight: '600'}"
            >
              <el-table-column align="center" prop="datasetName" label="数据集名称"></el-table-column>
              <el-table-column align="center" prop="datasetVersion" label="版本号" width="100"></el-table-column>
              <el-table-column align="center" prop="datasetNum" label="数据总量" width="100"></el-table-column>
              <el-table-column align="center" prop="labelIdNum" :label="datasetType == 1 ? '图片数':'已标注'" width="100"></el-table-column>
              <el-table-column align="center" prop="labelNames" label="标签名称"></el-table-column>
              <!-- ele 无数据提示插槽 -->
              <template slot="empty"><div class="noData">无数据</div></template>
            </el-table>
          </div>
    
          <h4 class="p">配置信息</h4>
          <div>
            <p class="p">
              <span><em class="span-color-black">增量学习：</em><em class="text">{{TrainingModelReport.incrementalLearningVersion || '无' }}</em></span>
              <span><em class="span-color-black">服务器：</em><em class="text">{{TrainingModelReport.server ? (TrainingModelReport.server==1 ? 'CPU':'GPU'):'系统随机分配'}}</em></span>
            </p>
            <p class="p">
              <span><em class="span-color-black">Epochs：</em><em class="text">{{TrainingModelReport.epoch || '系统随机分配'}}</em></span>
              <span><em class="span-color-black">BatchSize：</em><em class="text">{{TrainingModelReport.batchSize || '系统随机分配'}}</em></span>
            </p>
            <p class="p">
              <span><em class="span-color-black">学习率（LearningRate）：</em><em class="text">{{TrainingModelReport.learningRate || '系统随机分配'}}</em></span>
              <span><em class="span-color-black">迭代次数（Iteration）：</em><em class="text">{{TrainingModelReport.iteration || '系统随机分配'}}</em></span>
            </p>
          </div>
          <h4 class="p">训练时间<span class="span-color-ash">（用时：{{TrainingModelReport.timeMinutes}}）</span></h4>
          <div>
            <p class="p">
              <span><em class="span-color-black">开始时间：</em>{{TrainingModelReport.trainBeginTime}}</span>
              <span><em class="span-color-black">结束时间：</em>{{TrainingModelReport.trainEndTime}}</span>
            </p>
          </div>
    
          <h4 class="p">基础评估结果</h4>
          <div class="p">
            <figure class="figure">
              <div class="figure-column">
                <icon-base v-bind="Icons.ProgressCircle">
                  <progress-circle
                    :num="popupData.valReport ? (datasetType == 1 ? popupData.valReport.Accuracy : popupData.valReport.Precision) : 0"
                    :numName="datasetType == 1 ? 'Accuracy' : 'mAP'"
                  />
                </icon-base>
                <figcaption>
                  <template>{{ (datasetType == 1 ? 'Accuracy' : 'mAP') | strTrasform }}</template>
                </figcaption>
              </div>
              <div class="figure-column">
                <icon-base v-bind="Icons.ProgressCircle">
                  <progress-circle
                    :num="popupData.valReport ? (datasetType == 1 ? popupData.valReport.Precision : popupData.valReport.Recall) : 0"
                    :numName="datasetType == 1 ? 'Precision' : 'Recall'"
                  />
                </icon-base>
                <figcaption>
                  <template>{{ (datasetType == 1 ? 'Precision' : 'Recall') | strTrasform }}</template>
                </figcaption>
              </div>
              <div class="figure-column">
                <icon-base v-bind="Icons.ProgressCircle">
                  <progress-circle
                    :num="popupData.valReport ? (datasetType == 1 ? popupData.valReport.Recall : popupData.valReport.F1Score) : 0"
                    :numName="datasetType == 1 ? 'Recall' : 'F1-score'"
                  />
                </icon-base>
                <figcaption>
                  <template>{{ (datasetType == 1 ? 'Recall' : 'F1Score') | strTrasform }}</template>
                </figcaption>
              </div>
            </figure>
          </div>
          <h4 class="p" v-if="popupData.testReport && (datasetType == 1 ? popupData.testReport.Accuracy : popupData.testReport.Precision)">测试集评估结果</h4>
          <div class="p" v-if="popupData.testReport && (datasetType == 1 ? popupData.testReport.Accuracy : popupData.testReport.Precision)">
            <figure class="figure">
              <div class="figure-column">
                <icon-base v-bind="Icons.ProgressCircle">
                  <progress-circle
                    :num="popupData.testReport ? (datasetType == 1 ? popupData.testReport.Accuracy : popupData.testReport.Precision) : 0"
                    :numName="datasetType == 1 ? 'Accuracy' : 'mAP'"
                  />
                </icon-base>
                <figcaption>
                  <template>{{ (datasetType == 1 ? 'Accuracy' : 'mAP') | strTrasform }}</template>
                </figcaption>
              </div>
              <div class="figure-column">
                <icon-base v-bind="Icons.ProgressCircle">
                  <progress-circle
                    :num="popupData.testReport ? (datasetType == 1 ? popupData.testReport.Precision : popupData.testReport.Recall) : 0"
                    :numName="datasetType == 1 ? 'Precision' : 'Recall'"
                  />
                </icon-base>
                <figcaption>
                  <template>{{ (datasetType == 1 ? 'Precision' : 'Recall') | strTrasform }}</template>
                </figcaption>
              </div>
              <div class="figure-column">
                <icon-base v-bind="Icons.ProgressCircle">
                  <progress-circle
                    :num="popupData.testReport ? (datasetType == 1 ? popupData.testReport.Recall : popupData.testReport.F1Score) : 0"
                    :numName="datasetType == 1 ? 'Recall' : 'F1-score'"
                  />
                </icon-base>
                <figcaption>
                  <template>{{ (datasetType == 1 ? 'Recall' : 'F1Score') | strTrasform }}</template>
                </figcaption>
              </div>
            </figure>
          </div>
        </div>
      </div>

      <div class="div-buttons">
        <!-- <el-button type="primary" @click="ExportSavePdf(htmlTitle, nowTime)">导出PDF</el-button> -->
        <el-button id="renderPdf" type="primary" @click="uploadPdf">导出PDF</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import PRETRAIN from "@/axios/pretrain/pretrain.js";
import ProgressCircle from "@/components/icons/typography/ProgressCircle";

// 引入导出页面为PDF格式
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export default {
  name: 'ModelAssessmentReport',
  components: { ProgressCircle },
  props: {},
  data() {
    return {
      datasetType: '1', // 数据集类型：1图像分类，2图像检测，3文本分类，4文本标注，5音频分类，6音频标注
      activeModel: '',
      activeModelId: '',
      trainModelId: '',
      trainModelInfo: [], // 下载模型文件数据
      timeMinutes: '',
      TrainingModelReport: {}, // 评估报告
      htmlTitle: "评估报告",
      nowTime: "",
      popupData: {},
      Icons: {
        ProgressCircle: {
          iconName: "",
          viewBox: "0 0 120 120",
          width: "120",
          height: "120"
        }
      },
      currentdate: '',
    }
  },
  filters: {
    strTrasform(value) {
      var strs = {
        Accuracy: "准确率",
        Precision: "精准率",
        Recall: "召回率",
        mAP: "总体性能",
        F1Score: "F1分数",
      };

      return strs[value];
    }
  },
  watch: {},
  created() {
    this.datasetType = this.$route.query.datasetType || '';
    this.activeModel = this.$route.query.activeModel || '';
    this.activeModelId = this.$route.query.activeModelId || '';
    this.trainModelId = this.$route.query.trainModelId || '';
  },
  mounted() {
    this.currentdate = this.getdate(); // 获取当前时间
    this.getAssessmentReport();
  },
  methods: {
    isSplit (nodes, index, pageHeight) {
      // 计算当前这块dom是否跨越了a4大小，以此分割
      if (nodes[index].offsetTop + nodes[index].offsetHeight < pageHeight && nodes[index + 1] && nodes[index + 1].offsetTop + nodes[index + 1].offsetHeight > pageHeight) {
        return true;
      }
      return false;
    },
    // 打印PDF
    uploadPdf(){
      let ST = document.documentElement.scrollTop || document.body.scrollTop; 
      let SL = document.documentElement.scrollLeft || document.body.scrollLeft;
               document.documentElement.scrollTop = 0;
               document.documentElement.scrollLeft = 0;
               document.body.scrollTop = 0;
               document.body.scrollLeft = 0;
          //获取滚动条的位置并赋值为0，因为是el-dialog弹框，并且内容较多出现了纵向的滚动条,截图出来的效果只能截取到视图窗口显示的部分,超出窗口部分则无法生成。所以先将滚动条置顶
      const A4_WIDTH = 592.28;
      const A4_HEIGHT = 841.89;
      let imageWrapper = document.getElementById("pdfCentent"); // 获取DOM
      let pageHeight = imageWrapper.scrollWidth / A4_WIDTH * A4_HEIGHT;
      let lableListID = imageWrapper.querySelectorAll(".p");
      lableListID = Array.from(lableListID);
      // 进行分割操作，当dom内容已超出a4的高度，则将该dom前插入一个空dom，把他挤下去，分割
      for (let i = 0; i < lableListID.length; i++) {
        let multiple = Math.ceil((lableListID[i].offsetTop + lableListID[i].offsetHeight) / pageHeight);
        if (this.isSplit(lableListID, i, multiple * pageHeight)) {
          let divParent = lableListID[i].parentNode; // 获取该div的父节点
          let newNode = document.createElement('div');
              newNode.className = 'emptyDiv';
              newNode.style.background = '#ffffff';
          let _H = multiple * pageHeight - (lableListID[i].offsetTop + lableListID[i].offsetHeight);
          //留白
          newNode.style.height = _H + 30 + 'px';
          newNode.style.width = '100%';
          let next = lableListID[i].nextSibling; // 获取div的下一个兄弟节点
            // 判断兄弟节点是否存在
          if (next) {
            // 存在则将新节点插入到div的下一个兄弟节点之前，即div之后
            divParent.insertBefore(newNode, next);
          } else{
            // 不存在则直接添加到最后,appendChild默认添加到divParent的最后
            divParent.appendChild(newNode);
          }
        } 
      }

      //接下来开始截图
      this.$nextTick(() => {
        // nexttick可以保证要截图的部分全部执行完毕，具体用法自行百度...
        html2canvas(imageWrapper, {
          allowTaint: true,
          // x: imageWrapper.getBoundingClientRect().left + 13,     // 绘制的dom元素相对于视口的位置
          // y: imageWrapper.getBoundingClientRect().top,        
          width: imageWrapper.offsetWidth,                   // 因为多出的需要剪裁掉，
          height: imageWrapper.offsetHeight,
          backgroundColor: "#FFF", //一定要设置北京颜色，否则有的浏览器就会变花~，比如Edge
          useCORS: true,
          scale: 3,      // 图片模糊
          dpi: 350, //z
        }).then((canvas) => {
          let pdf = new jsPDF('p', 'mm', 'a4');    //A4纸，纵向
          let ctx = canvas.getContext('2d'),
          a4w = 190, a4h = 277,    //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
          //   var a4w = 180; var a4h = 257 // A4大小，210mm x 297mm，四边各保留20mm的边距，显示区域170x257
          imgHeight = Math.floor(a4h * canvas.width / a4w),    //按A4显示比例换算一页图像的像素高度
          renderedHeight = 0;

          while(renderedHeight < canvas.height) {
            let page = document.createElement("canvas");
            page.width = canvas.width;
            page.height = Math.min(imgHeight, canvas.height - renderedHeight);//可能内容不足一页
            //用getImageData剪裁指定区域，并画到前面创建的canvas对象中
            page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0);
            pdf.addImage(page.toDataURL('image/jpeg', 0.2), 'JPEG', 10, 10, a4w, Math.min(a4h, a4w * page.height / page.width));    //添加图像到页面，保留10mm边距
            renderedHeight += imgHeight;
            if (renderedHeight < canvas.height)
              pdf.addPage();//如果后面还有内容，添加一个空页
            }
            // 打印pdf页面
            pdf.save('评估报告.pdf');
            // 上传到后端
            // let uploadPdf =  pdf.output("datauristring") //转成Base64
            //  let arr = uploadPdf.split(',')
            //  let mime = arr[0].match(/:(.*?);/)[1]
            //  let suffix = mime.split('/')[1]
            //  let bstr = window.atob(arr[1])  //自行百度新大陆
            //  let n = bstr.length
            //  let u8arr = new Uint8Array(n)
            //  let filename="temp_img";
            //  while (n--) {
            //        u8arr[n] = bstr.charCodeAt(n)
            //  }
            //  let file =  new File([u8arr], `${filename}.${suffix}`, {type: mime});   
            //  let formdata = new FormData();
            //  formdata.append("uploadfile",file);
            //  let params={project:this.pid,courseid:this.id}
            //  this.$axios({
            //       url:`vueindex/UploadWord/uploadpdf`,
            //       method:"post",
            //       headers:{'Content-Type':"multipart/form-data "},
            //       data:formdata,
            //       params:params        
            //   }).then((res)=>{
            //       if(res.data.code == 0){
            //          //上传成功，刷新页面，打完收工
            //       }
            //   })
        })
      })
    },
    // 时间戳转日期时间格式'yy-MM-dd hh:mm:ss'
    getdate(val) {
      var date = val ? new Date(val) : new Date(); // 当前时间戳
      var YY = date.getFullYear() + '-';
      var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
      var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());

      let dateText = ''
      if (val) {
        dateText = YY + MM + DD +" "+hh + mm + ss;
      } else {
        dateText = YY + MM + DD;
      }
      // return YY + MM + DD +" "+hh + mm + ss;
      return dateText;
    },
    //计算两个时间之间的时间差 多少天时分秒
    intervalTime(startTime,endTime) {
      var date1 = startTime; //开始时间
      var date2 = endTime; //结束时间
      var date3 =  (date2- date1); //时间差的毫秒数
      //计算出相差天数
      var days = Math.floor(date3 / (24 * 3600 * 1000));
      //计算出小时数
  
      var leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
      var hours = Math.floor(leave1 / (3600 * 1000));
      //计算相差分钟数
      var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      var minutes = Math.floor(leave2 / (60 * 1000));
  
      //计算相差秒数
      var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
      var seconds = Math.round(leave3 / 1000);
      // console.log(days + "天 " + hours + "小时 " + minutes + " 分钟" + seconds + " 秒")
      // var dateText = (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
      var dateText = `${hours} 小时 ${minutes} 分钟 ${seconds} 秒`;
      return dateText;
    },
    // 计算时间差
    calculationTimeDifference(time1, time2) {
      // 时间格式'yy-MM-dd hh:mm:ss' 转换时间戳
      var timestamp1 = Date.parse(new Date(time1));
      var timestamp2 = Date.parse(new Date(time2));
      // var timeDifference = timestamp2 - timestamp1;
      // 时间戳转换分钟

      // var currentdate = timeDifference/1000/60;
      // // parseFloat(去除小数点后多余的0) toFixed(保留n位小数)
      // currentdate = parseFloat(currentdate.toFixed(2));
      let currentdate =  this.intervalTime(timestamp1, timestamp2)
      return currentdate;
    },
    // 获取模型报告
    getAssessmentReport(params) {
      let data = {
        trainModelId: this.trainModelId, // 训练模型id
        type: this.datasetType, // 类型：1为图像分类;2为物体检测;
      }
      PRETRAIN.getAssessmentReport(data).then(result => {
        if (result.isSuccess || result.returnCode == 200) {
          this.TrainingModelReport = result.data;
          this.TrainingModelReport.trainSetList = [this.TrainingModelReport.trainSet];
  
          let time1 = this.TrainingModelReport.trainBeginTime;
          let time2 = this.TrainingModelReport.trainEndTime;
          this.TrainingModelReport.timeMinutes = this.calculationTimeDifference(time1, time2); // 计算时间差

          this.popupData = JSON.parse(this.TrainingModelReport.assessmentResult); // 评估结果
        } else {
          this.$message.error(result.returnMsg);
        }
      });
    },
    // 返回模型训练
    onBlackModel() {
      this.$router.push({
        path: `/pretrain/${this.datasetType}/model/list`,
        query: { 
          modelType: this.datasetType, // 模型训练类型
          activeModel: this.activeModel, // 位置下标
          activeModelId: this.activeModelId, // 模型id
        }
      });
    },
  },
}
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
em {
  font-style: normal;
}
.model-assessment-report {
  width: 100%;
  min-height: 100%;
  background-color: #f2f5fc;
  background-size: cover;
  background-position: center;
  color: #666;
  padding: 80px 0 60px;
  .nav-head-right {
    width: 800px;
    height: 60px;
    line-height: 60px;
    margin: 0 auto;
    .go-to-dataset {
      color: #4c88ff;
      font-size: 14px;
      font-weight: bold;
      float: right;
      cursor: pointer;
      .el-icon-right {
        margin-right: 5px;
        font-weight: bold;
      }
    }
  }
  .popup-content {
    // height: calc(100% - 60px);
    width: 800px;
    background-color: #fff;
    margin: 0 auto;
    padding: 20px 20px 120px;
    position: relative;
    .pdfCentent {
      // height: 100%;
      max-height: 100%;
      h3 {
        color: #333;
        font-size: 24px;
        text-align: center;
        // margin: -40px 0 20px;
      }
      .progress {
        // height: calc(100% - 60px);
        // height: 530px;
        // overflow-x: hidden;
        // overflow-y: auto;
        .userName {
          color: #333;
          font-size: 14px;
          font-weight: 600;
          text-align: right;
          margin: 10px 0;
        }
        .span-color-black {
          color: #333;
          font-weight: 600;
        }
        .span-color-ash {
          color: #666;
          font-size: 12px;
        }
        h4 {
          height: 16px;
          color: #4c88ff;
          border-left: 3px solid #4c88ff;
          font-size: 16px;
          line-height: 17px;
          padding-left: 6px;
          margin: 20px 0 10px;
        }
        h6 {
          color: #4c88ff;
          font-size: 14px;
          margin: 5px 0;
        }
        p {
          font-size: 14px;
          line-height: 14px;
          margin: 10px 0;
          display: flex;
          flex-wrap: nowrap;
          span {
            flex: 1;
            // width: 50%;
            display: flex;
            padding: 0 6px;
            .text {
              flex: 1;
              word-break: break-all;
              word-wrap: break-word;
              white-space: pre-wrap;
            }
          }
        }
        .figure {
          display: flex;
          justify-content: space-between;
          .figure-column {
            text-align: center;
          }
          // figcaption {
          //   margin-top: 15px;
          // }
        }
      }
      .pdf-visible {
        height: auto;
        overflow-y: visible;
      }
    }

    .div-buttons {
      position: absolute;
      bottom: 50px;
      left: 0;
      right: 0;
      margin: auto;
      text-align: center;
      padding: 0 30px;
      .el-button {
        width: 90px;
        height: 40px;
        // padding: 0 10px;
        &.el-button--primary {
          background: #4c88ff;
          border-color: #4c88ff;
          &:hover {
            background: #409EFF;
            border-color: #409EFF;
          }
        }
      }
    }
  }
}
</style>
